/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  DeleteApiV1CoursefinancialCoursefinancialidLangsId204,
  DeleteApiV1CoursefinancialCoursefinancialidLangsId400,
  DeleteApiV1CoursefinancialCoursefinancialidLangsId401,
  DeleteApiV1CoursefinancialCoursefinancialidLangsId404,
  DeleteApiV1CoursefinancialCoursefinancialidLangsId500,
  DeleteApiV1CoursefinancialCoursefinancialidLangsIdMutationResponse,
  DeleteApiV1CoursefinancialCoursefinancialidLangsIdPathParams,
} from "../../types/courseFinancialLangsController/DeleteApiV1CoursefinancialCoursefinancialidLangsId.ts";

export const deleteApiV1CoursefinancialCoursefinancialidLangsIdPathParamsSchema =
  z.object({
    courseFinancialId: z.coerce.number().int(),
    id: z.coerce.number().int(),
  }) as unknown as ToZod<DeleteApiV1CoursefinancialCoursefinancialidLangsIdPathParams>;

/**
 * @description (No Content) Requisição não encontrou resultados.
 */
export const deleteApiV1CoursefinancialCoursefinancialidLangsId204Schema =
  z.any() as unknown as ToZod<DeleteApiV1CoursefinancialCoursefinancialidLangsId204>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const deleteApiV1CoursefinancialCoursefinancialidLangsId400Schema =
  z.any() as unknown as ToZod<DeleteApiV1CoursefinancialCoursefinancialidLangsId400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const deleteApiV1CoursefinancialCoursefinancialidLangsId401Schema =
  z.any() as unknown as ToZod<DeleteApiV1CoursefinancialCoursefinancialidLangsId401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const deleteApiV1CoursefinancialCoursefinancialidLangsId404Schema =
  z.any() as unknown as ToZod<DeleteApiV1CoursefinancialCoursefinancialidLangsId404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const deleteApiV1CoursefinancialCoursefinancialidLangsId500Schema =
  z.any() as unknown as ToZod<DeleteApiV1CoursefinancialCoursefinancialidLangsId500>;

export const deleteApiV1CoursefinancialCoursefinancialidLangsIdMutationResponseSchema =
  z.lazy(
    () => deleteApiV1CoursefinancialCoursefinancialidLangsId204Schema,
  ) as unknown as ToZod<DeleteApiV1CoursefinancialCoursefinancialidLangsIdMutationResponse>;
